import React, { useState, useEffect} from "react";
import "./configuracion.css";
import moment from "moment";
import { NavLink as RRNavLink } from "react-router-dom";
import { CLOSE_IMAGE } from "../Componentes/Image";
import { PublicidadModal, ImageTooltipModalPublicidad, MesasModal } from "./../Componentes/Modal";
import {DATATABLE_GARANTIA,DATATABLE_MESAS,DATATABLE_PUBLICIDAD} from "../Componentes/Datatables";
import { DeleteModal,GarantiaModal} from "./../Componentes/Modal";
import { MDBIcon,MDBTabs,MDBTabsItem,MDBTabsLink,MDBTabsContent,MDBTabsPane} from "mdb-react-ui-kit";
import {get_img_publicidad,put_res_restaurante,put_res_restaurante_sts,post_res_restaurante,get_res_restaurante, put_gr_garantia,  put_gr_garantia_sts,  post_gr_garantia,
  get_gr_garantia,put_delete_img_publicidad, imgURLServerPublicidad,post_img_publicidad,
  put_res_restaurante_inactivo} from "../Componentes/Services";
import { Container, Row, Col, NavLink } from "reactstrap";


export const Configuracion = () => {
  const [error, setError] = useState("");
  const [basicModal, setBasicModal] = useState(false);
  const [iconsActive, setIconsActive] = useState("tab1");
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const handleIconsClick = (value) => {
    if (value === iconsActive) {
      return;
    }
    setIconsActive(value);
  };

  return (
    <div className="cfg-admin font-s12px">
      <header className="cfg-header">
        <div className="cfg-header-info">
          <h1 className="cfg-title">Administración</h1>
          <p className="cfg-subtitle">Configuración del sistema</p>
        </div>
        <MDBTabs className="cfg-tabs">
          <MDBTabsItem>
            <MDBTabsLink onClick={() => handleIconsClick("tab1")} active={iconsActive === "tab1"}>
              <MDBIcon fas icon="shield-alt" className="me-2" /> Garantías
            </MDBTabsLink>
          </MDBTabsItem>
          <MDBTabsItem>
            <MDBTabsLink onClick={() => handleIconsClick("tab2")} active={iconsActive === "tab2"}>
              <MDBIcon fas icon="bullhorn" className="me-2" /> Publicidad
            </MDBTabsLink>
          </MDBTabsItem>
          <MDBTabsItem>
            <MDBTabsLink onClick={() => handleIconsClick("tab3")} active={iconsActive === "tab3"}>
              <MDBIcon fas icon="utensils" className="me-2" /> Mesas Restaurante
            </MDBTabsLink>
          </MDBTabsItem>
        </MDBTabs>
        <NavLink tag={RRNavLink} to="/user/home" className="cfg-close" title="Cerrar">
          <img src={CLOSE_IMAGE} alt="Cerrar" />
        </NavLink>
      </header>
      <MDBTabsContent className="cfg-content">
        <MDBTabsPane show={iconsActive === "tab1"} className="overflow-c">
          <Garantia setError={setError} error={error} setBasicModal={setBasicModal} basicModal={basicModal} basicModalDelete={basicModalDelete} 
          setBasicModalDelete={setBasicModalDelete} basicModalEdit={basicModalEdit} setBasicModalEdit={setBasicModalEdit} isLoading={isLoading} 
          setLoading={setLoading} />
        </MDBTabsPane>
        <MDBTabsPane show={iconsActive === "tab2"}>
          <Publicidad setError={setError} error={error} setBasicModal={setBasicModal} basicModal={basicModal} basicModalDelete={basicModalDelete} setBasicModalDelete={setBasicModalDelete}
           basicModalEdit={basicModalEdit} setBasicModalEdit={setBasicModalEdit} isLoading={isLoading} setLoading={setLoading} />
        </MDBTabsPane>
        <MDBTabsPane show={iconsActive === "tab3"}>
          <Restaurante setError={setError} error={error} setBasicModal={setBasicModal} basicModal={basicModal} basicModalDelete={basicModalDelete} setBasicModalDelete={setBasicModalDelete}
           basicModalEdit={basicModalEdit} setBasicModalEdit={setBasicModalEdit} isLoading={isLoading} setLoading={setLoading} />
        </MDBTabsPane>
      </MDBTabsContent>
    </div>
  );
};

function Garantia({setError,error,basicModal,setBasicModal,setBasicModalDelete,basicModalDelete,basicModalEdit,setBasicModalEdit,isLoading,setLoading}) {
  const [dataGarantia, setDataGarantia] = useState([]);
  const [formGarantia, setFormGarantia] = useState({
    gr_id: "",
    gr_name: "",
    gr_descripcion: "",
    gr_sts: "",
  });

  const onClickUpdateGarantia = () => {
    setLoading(true);
    var body = {
      gr_id: formGarantia.gr_id,
      gr_name: formGarantia.gr_name,
      gr_descripcion: formGarantia.gr_descripcion,
    };

    var result = put_gr_garantia(body);
    result.then((data) => {
      setError("");
      if (data === true) {
        setLoading(false);
        fetchGarantia();
      } else setError("ERROR " + data);
    });
  };

  const onClickUpdateGarantia_sts = () => {
    var body = {
      gr_id: formGarantia.gr_id,
      gr_sts: 0,
    };

    var result = put_gr_garantia_sts(body);
    result.then((data) => {
      setError("");
      if (data === true) fetchGarantia();
      else setError("ERROR " + data);
    });
  };

  const onClickSaveGarantia = () => {
    setLoading(true);
    var body = {
      gr_name: formGarantia.gr_name,
      gr_descripcion: formGarantia.gr_descripcion,
    };
    if (formGarantia.gr_descripcion.length > 0 && formGarantia.gr_name.length) {
      var result = post_gr_garantia(body);
      result.then((data) => {
        setError("");
        if (data === true) {
          setLoading(false);
          fetchGarantia();
        } else setError("ERROR " + data);
      });
    } else {
      setError("Campos importantes estan vacios");
       setLoading(false);
    }
  };

  async function fetchGarantia() {
    setLoading(true);
    var response;
    response = await get_gr_garantia();
    setDataGarantia(response);
    setBasicModal(false);
    setBasicModalDelete(false);
    setBasicModalEdit(false);
    setLoading(false);
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormGarantia({
      ...formGarantia,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchGarantia();
  }, []);

  return (
    <Container fluid className="cfg-panel font-s12px">
      {basicModal && (
        <GarantiaModal
          props={formGarantia}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveGarantia}
          toggleSaveEdit={onClickUpdateGarantia}
          onChange={onChange}
          error={error}
          loading={isLoading}
          setLoading={setLoading}
        />
      )}
      {basicModalDelete && (
        <DeleteModal
          props={formGarantia.gr_name}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateGarantia_sts}
          text={"Eliminar este registro?"}
          error={error}
        />
      )}
        <div className="cfg-card modal-add-inventario datatable-factura css_datatable1">
          <DATATABLE_GARANTIA
            dataGarantia={dataGarantia}
            setBasicModalDelete={setBasicModalDelete}
            setFormGarantia={setFormGarantia}
            setBasicModal={setBasicModal}
            setBasicModalEdit={setBasicModalEdit}
            setError={setError}
            fetchGarantia={fetchGarantia}
            isLoadingG={isLoading}
          />
        </div>
    </Container>
  );
}

function Publicidad({setError,error,basicModal,setBasicModal,setBasicModalDelete,basicModalEdit,basicModalDelete,setBasicModalEdit,isLoading,setLoading}) {
  const [srcImage, setSrcImage] = useState("");
  const [basicModalImageTooltip, setModalImageTooltip] = useState(false);
  const [images, setImages] = React.useState([]);
  const [dataPublicidad, setDataPublicidad] = useState([]);
  const [formPublicidad, setFormPublicidad] = useState({
    img_id: "",
    img_name: "",
    img_sts: "",
    img_dataurl: "",
    img_type: "",
  });

  async function fetchPublicidad() {
    setLoading(true);
    var response;
    response = await get_img_publicidad();
    setDataPublicidad(response);
    setLoading(false);
    setError("");
    setBasicModal(false);
    setBasicModalDelete(false)
  }

  const removeImage = () => {
    var body = {
      img_id: formPublicidad.img_id,
    };

    var result = put_delete_img_publicidad(body);
    result.then((data) => {
      setError("");
      if (data === true) {
        setFormPublicidad({
          ...formPublicidad,
          img_id: "",
          img_name: "",
          img_sts: "",
          img_dataurl: "",
          img_type: "",
        });
        fetchPublicidad();
      } else setError("ERROR " + data);
    });
  };
  const onChangeImage = (imageList) => {
    setFormPublicidad({
      ...formPublicidad,
      img_dataurl: imageList[0] === undefined ? "" : imageList[0].data_url,
      img_type: imageList[0] === undefined ? "" : imageList[0].file.type,
    });
    setImages(imageList);
    setError("");
  };
  useEffect(() => {
    fetchPublicidad();
  }, []);

  const toggleSave = () => {
    var body = {
      img_id: formPublicidad.img_id,
      img_dataurl: formPublicidad.img_dataurl,
      img_type: formPublicidad.img_type !== undefined ? formPublicidad.img_type : "none",
      img_URLServer: imgURLServerPublicidad,
      img_name:
        formPublicidad.img_dataurl !== undefined
          ? moment(new Date()).format("YYYYMMDDHHmmss")
          : formPublicidad.img_name,
    };
    if (formPublicidad.img_dataurl.length > 0 && formPublicidad.img_type.length > 0) {
      var result = post_img_publicidad(body);
      result.then((data) => {
        setError("");
        if (data === true) {
          setLoading(false);
          fetchPublicidad();
        } else setError("ERROR " + data);
      });
    }
     else {
      setError("Campos importantes estan vacios");
      setLoading(false);
    }
  };

  return (
    <Container fluid className="cfg-panel font-s12px">
      {basicModalImageTooltip && (
        <ImageTooltipModalPublicidad
          isOpen={basicModalImageTooltip}
          toggle={setModalImageTooltip}
          srcImage={srcImage}
          ImgName={srcImage}
        />
      )}
      {basicModalDelete && (
        <DeleteModal
          props={formPublicidad.img_id}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={removeImage}
          text={"Eliminar este registro?"}
          error={error}
        />
      )}
      {basicModal && (
        <PublicidadModal
          toggle={setBasicModal}
          isOpen={basicModal}
          props={formPublicidad}
          onChangeImage={onChangeImage}
          images={images}
          removeImage={removeImage}
          basicModalEdit={basicModalEdit}
          toggleSave={toggleSave}
          loading={isLoading}
          error={error}   
        />
      )}
      <Row>
        <Col xs={12} className="cfg-card modal-add-inventario datatable-factura css_datatable1">
          <DATATABLE_PUBLICIDAD
            datapublicidad={dataPublicidad}
            setFormPublicidad={setFormPublicidad}
            removeImage={removeImage}
            fetchPublicidad={fetchPublicidad}
            setBasicModal={setBasicModal}
            setError={setError}
            setImages={setImages}
            setSrcImage={setSrcImage}
            setModalImageTooltip={setModalImageTooltip}
            setBasicModalDelete={setBasicModalDelete}
          />
        </Col>
      </Row>
    </Container>
  );
}

function Restaurante({setError,error,basicModal,setBasicModal,setBasicModalDelete,basicModalEdit,basicModalDelete,setBasicModalEdit,isLoading,setLoading}) {
  const [dataRestaurante, setDataRestaurante] = useState([]);
  const [formRestaurante, setFormRestaurante] = useState({
    res_id: "",
    res_nombre: "",
    res_active:"",
    res_sts: "",
  });

  const onClickUpdateRestaurante = () => {
    var body = {
      res_id: formRestaurante.res_id,
      res_nombre: formRestaurante.res_nombre,
    };
    var result = put_res_restaurante(body);
      result.then((data) => {
      setError("");
      if (data === true) fetchRestaurante();
      else setError("ERROR " + data);
    });
  };

  const set_mesa_inactiva = (row) => {
    
    var body = {
      res_id: row.res_id,
      res_active: row.res_active==="1"?"":"1",
    };
    var result = put_res_restaurante_inactivo(body);
    result.then((data) => {
      setError("");
      if (data === true) fetchRestaurante();
      else setError("ERROR " + data);
    });
  };
  const onClickUpdateRestaurante_sts = () => {
    var body = {
      res_id: formRestaurante.res_id,
      res_sts: 0,
    };
    var result = put_res_restaurante_sts(body);
    result.then((data) => {
      setError("");
      if (data === true) fetchRestaurante();
      else setError("ERROR " + data);
    });
  };

  const onClickSaveRestaurante = () => {
    if (formRestaurante.res_nombre.length > 0) {
      var body={
        res_nombre:formRestaurante.res_nombre
      }
      var result = post_res_restaurante(body);
      result.then((data) => {
        setError("");
        if (data === true) fetchRestaurante();
        else setError("ERROR " + data);
      });
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchRestaurante() {
    setLoading(true);
    var response;
    response = await get_res_restaurante();
    setDataRestaurante(response);
    setBasicModalDelete(false);
    setBasicModalEdit(false);
    setBasicModal(false);
    setLoading(false);
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormRestaurante({
      ...formRestaurante,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchRestaurante();
  }, []);

  return (
    <Container fluid className="cfg-panel font-s12px">
      {basicModalDelete && (
        <DeleteModal
          props={formRestaurante.res_nombre}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateRestaurante_sts}
          text={"Eliminar este registro?"}
          error={error}
        />
      )}
      {basicModal && (
        <MesasModal
          props={formRestaurante}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveRestaurante}
          toggleSaveEdit={onClickUpdateRestaurante}
          onChange={onChange}
          error={error}
          loading={isLoading}
          setLoading={setLoading}
        />
      )}
      <div className="cfg-card modal-add-inventario datatable-factura css_datatable1">
          <DATATABLE_MESAS
            dataRestaurante={dataRestaurante}
            setBasicModalDelete={setBasicModalDelete}
            setFormRestaurante={setFormRestaurante}
            setBasicModal={setBasicModal}
            setBasicModalEdit={setBasicModalEdit}
            setError={setError}
            fetchRestaurante={fetchRestaurante}
            isLoadingG={isLoading}
            set_mesa_inactiva={set_mesa_inactiva}
          />
        </div>
    </Container>
  );
}